import { LocalLandingPageHero } from "./LocalLandingPageHero";

export const UniversalRender = LocalLandingPageHero;
